// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 443 ? "about" : chunkId) + "-legacy." + {"443":"346462db","856":"26c51027","935":"e6028468"}[chunkId] + ".js";
};